const googleMapsApiKey = (
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
).trim();

export default googleMapsApiKey;
